import type { Store, StoreTimeSchedule } from 'maps/types'

export type DataFromDetails = {
	id: string
	addresses: {
		address: string
		postalCode: string
		city: string
		shoppingCenter: string | null
		coordinates: {
			latitude: number
			longitude: number
			distance: number
		}
	}
	collections: string[]
	timeSchedule: StoreTimeSchedule[]
	phone: string
	isCorner: boolean
	urlVisitStore: string | null
	showVisitStore: boolean
	sizes: string[]
	sizesIds: {
		id: string
		name: string
		isLastUnit: boolean
	}[]
	tiposVenta?: string[]
}

export function fromDetails(data: DataFromDetails): Store {
	validateData(data)
	const { id, collections, addresses, ...details } = data
	return {
		id,
		collections,
		details,
		addresses: {
			address: addresses.address,
			city: addresses.city,
			postalCode: addresses.postalCode,
			shoppingCenter: addresses.shoppingCenter,
			coordinates: {
				distance: addresses.coordinates.distance,
				lat: addresses.coordinates.latitude,
				lng: addresses.coordinates.longitude,
			},
		},
	}
}

function validateData(data: DataFromDetails): void {
	if (!data?.id) {
		throw new Error('[Maps] Invalid data from store service')
	}
}
